// src/Screens/RoomsHub.jsx
// "Find a public game", opened from Home. It used to be its own Rooms tab,
// but that tab only repeated Home's link to the same list, so (as on mobile)
// it was folded into Home. /rooms keeps working for bookmarks and links.
import React from "react";
import { useNavigate } from "react-router-dom";
import PublicRoomsContent from "./PublicRoomsContent";

const RoomsHub = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto sm:max-w-2xl">
      <PublicRoomsContent onBack={() => navigate("/")} />
    </div>
  );
};

export default RoomsHub;
